import { ExpirationPlugin } from 'workbox-expiration';
import { createHandlerBoundToURL } from 'workbox-precaching';
import { registerRoute } from 'workbox-routing';
import { StaleWhileRevalidate, CacheFirst } from 'workbox-strategies';
import { googleFontsCache } from 'workbox-recipes';

export const setupAssetsCaching = () => {
    googleFontsCache();

    // Cache routes for Cloudinary assets using CacheFirst strategy.
    registerRoute(
        ({ url }) => url.host === 'res.cloudinary.com',
        new CacheFirst()
    );

    // Handler for HTML navigation requests not matching specific resource patterns.
    const fileExtensionRegexp = new RegExp('/[^/?]+\\.[^/]+$');
    const indexHtmlHandler = createHandlerBoundToURL('/index.html');
    registerRoute(
        ({ request, url }) => request.mode === 'navigate'
            && !url.pathname.startsWith('/_')
            && !url.pathname.match(fileExtensionRegexp),
            async (options) => {
              // Start the freshness check in the background
              const response = await indexHtmlHandler(options);
              const freshnessCheck = fetch(options.request).then(async response => {
                  const cache = await caches.open('logged-in-cached-data');
                  const cachedResponse = await cache.match('/index.html');

                  console.log(`[service-worker] checking freshness: ${options.request.url}`);

                  if (cachedResponse !== undefined) {
                      if (response.headers.get('ETag') !== cachedResponse.headers.get('ETag')) {
                          console.log(`[service-worker] app update available`);
                          cache.put('showUpdate', new Response('true'));
                      } else {
                          console.log(`[service-worker] app update not available`);
                          cache.put('showUpdate', new Response('false'));
                      }
                  }

                  await cache.put('/index.html', response);
              }).catch(err => {
                  console.log(`[service-worker] freshness check failed:`, err);
              });

              // Immediately serve index.html while the check happens in background
              return response;
          },
    );

    // Cache same-origin PNG files using StaleWhileRevalidate strategy.
    const imageCacheName = 'images';
    registerRoute(
        ({ url }) => url.origin === self.location.origin && url.pathname.endsWith('.png'),
        new StaleWhileRevalidate({
            cacheName: imageCacheName,
            plugins: [
                // Ensure that once this runtime cache reaches a maximum size the
                // least-recently used images are removed.
                new ExpirationPlugin({ maxEntries: 50 })
            ]
        })
    );
};

